import { render, staticRenderFns } from "./crashLayout.vue?vue&type=template&id=620e4994&"
import script from "./crashLayout.vue?vue&type=script&lang=js&"
export * from "./crashLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports